module.exports = __webpack_public_path__ + "static/media/save-money.8c49bbcd.svg";